<mat-toolbar>
	<div class="user-panel">
		<button mat-button [matMenuTriggerFor]="beforeMenu" class="my-profile-btns" matRipple>
			{{user?.first_name}} {{user?.last_name}}
		</button>
		<mat-menu #beforeMenu="matMenu" xPosition="before">
			<a (click)="logout()" class="profile-link logout" mat-menu-item>Logout</a>
		</mat-menu>
	</div>
</mat-toolbar>